import React, { Component } from "react";
import styles from "./cmsUsersCompanyPanel.module.scss";
import { withRoles } from "../../../shared/containers/containerRoles";
import { states } from "../../../reducers/queriesStates";
import { withUsers } from "../../../shared/containers/containerUsers";
import { Select, MenuItem, TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";

class UserCreateTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: props.companyId,
      newUser: {
        email: "",
        roleType: 0,
      },
      error: null,
    };
  }

  componentDidMount() {
    const { rolesDataState, onGetRoles } = this.props;

    if (rolesDataState !== states.READY) {
      onGetRoles();
    }
  }

  componentDidUpdate(prevProps) {
    const { createUserDataState, errors } = this.props;

    if (createUserDataState === states.FAILURE && prevProps.createUserDataState === states.REQUEST) {
      this.setState({ error: errors });
      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (createUserDataState === states.READY && prevProps.createUserDataState === states.REQUEST) {
      this.setState({
        newUser: {
          email: "",
          roleType: 0,
        },
      });
    }
  }

  changeEmail(e) {
    const { newUser } = this.state;
    newUser.email = e.target.value;

    this.setState({ newUser });
  }

  changeRoleType(e) {
    const { newUser } = this.state;
    newUser.roleType = e.target.value;

    this.setState({ newUser });
  }

  createNewUser() {
    const { newUser, companyId } = this.state;
    const { onCreateUser } = this.props;

    onCreateUser({ ...newUser, companyId });
  }

  render() {
    const { newUser, error } = this.state;
    const { roles, createUserDataState } = this.props;

    return (
      <div className={styles.userCreateToolsContainer}>
        <div>
          {error !== null ? <div className={styles.addUserError}>{error}</div> : null}
          <TextField
            size="small"
            label="Почта нового пользователя "
            inputProps={{ sx: { width: "300px" } }}
            variant="outlined"
            value={newUser.email}
            onChange={this.changeEmail.bind(this)}
          />
        </div>

        <div>
          <Select style={{ minWidth: "200px" }} onChange={this.changeRoleType.bind(this)} size="small">
            <MenuItem value={newUser.roleType}>{"- - - "}</MenuItem>
            {roles.map((role) => {
              return (
                <MenuItem key={role.id} value={role.roleType}>
                  {role.title}
                </MenuItem>
              );
            })}
          </Select>
        </div>

        <div>
          {createUserDataState === states.REQUEST ? null : (
            <ButtonPrimary
              disabled={newUser.email === "" || newUser.roleType === 0}
              handleClick={this.createNewUser.bind(this)}
              title="Создать"
            />
          )}
        </div>

        {createUserDataState === states.REQUEST ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withUsers(withRoles(UserCreateTools));
